export const setupAnchorLinks = () => {
  const anchorLinks = document.querySelectorAll('.anchorLink');
  anchorLinks.forEach((anchorLink) => {
    const anchorLinkText = anchorLink.textContent;
    const anchorLinkId = anchorLinkText?.replace(' ', '');
    anchorLink.setAttribute('id', `anchor${anchorLinkId}`);
    const anchorLinksNav = document.querySelector('.anchorLinkNav .anchor-links');
    if (anchorLinksNav) {
      anchorLinksNav.innerHTML += `<li><a href='#anchor${anchorLinkId}'>${anchorLinkText}</a></li>`;
    }
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      if (matchMedia('(min-width: 60em)').matches) {
        const target = document.querySelector(this.getAttribute('href'));
        const header = document.querySelector('.header') as HTMLElement;
        if (target && header) {
          const headerHeight = header.offsetHeight;
          const targetOffset = target.offsetTop - headerHeight;
          window.scrollTo({
            top: targetOffset,
            behavior: 'smooth',
          });
        }
      }
    });
  });

  if (window.location.hash && matchMedia('(min-width: 60em)').matches) {
    const target = document.querySelector(window.location.hash);
    const header = document.querySelector('.header') as HTMLElement;
    if (target && header) {
      const headerHeight = header.offsetHeight;
      const targetOffset = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetOffset,
        behavior: 'smooth',
      });
    }
  }
};
